import { fetchQuery } from 'relay-runtime';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const query = graphql`
  query getJobContractPreviewQuery($jobId: ID!) {
    previewJobContract(jobId: $jobId) {
      pdfFile
      errors
    }
  }
`;

export default jobId =>
  fetchQuery(getEnvironment(), query, { jobId }).then(data => data.previewJobContract);









